import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rzline-hyzx",
  "use": "icon-rzline-hyzx-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"icon-rzline-hyzx\">\n  <defs>\n    <style>\n      #icon-rzline-hyzx .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-rzline-hyzx_icon_hyzx\" class=\"cls-1\" d=\"M2059,972h7v1h-7v-1Zm-3,9h13v1h-13v-1Zm0-13h1v14h-1V968Zm12,0h1v14h-1V968Zm-12,0h13v1h-13v-1Zm-6-5h1v14h-1V963Zm12,0h1v6h-1v-6Zm-12,13h7v1h-7v-1Zm0-13h13v1h-13v-1Zm9,12h7v1h-7v-1Zm0,3h5v1h-5v-1Z\" transform=\"translate(-2050 -963)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/rzline-hyzx.svg
// module id = tval
// module chunks = 70